import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormElement from '../../../components/Steps/FormElement';
import {
  CustomCardWrapper, Title, CardBody,
} from './styles';

class ElementForm extends Component {
  componentDidMount() {
    const { match: { params: { id } } } = this.props;
    const { getElementById } = this.props;
    getElementById(parseInt(id, 10));
  }

  render() {
    const { element, literals } = this.props;
    const data = literals.modifyChallenge;
    return (
      <CustomCardWrapper color='#173630' id='card-body'>
        <Title maxFontSize='28' dangerouslySetInnerHTML={{ __html: data }} />
        <CardBody>
          <FormElement color='#173630' data={element} elementType='challenge' narrativeType='editElement' />
        </CardBody>
      </CustomCardWrapper>
    );
  }
}

ElementForm.propTypes = {
  match: PropTypes.object.isRequired,
  getElementById: PropTypes.func.isRequired,
};

export default ElementForm;



// WEBPACK FOOTER //
// ./src/routes/ElementForm/components/index.jsx